module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/cms-panel.35180de3.svg";